
<template>
  <div>
    <v-checkbox
      v-model="fill_later"
      label="Preencher frete, motorista e placa depois"
      color="primary"
    />
    <template v-if="!fill_later">
      <v-switch :label="switch_message" color="blue"
        v-model="order.delivery_attributes.internal" @change="resetDriverAndTruck">
      </v-switch>
      
      <template v-if="its_internal_drivers">
        <v-autocomplete v-model="order.driver" :items="allDrivers" label="Motorista interno"
        prepend-icon="mdi-account" item-text="attributes.name" return-object>
          <template v-slot:no-data>
            <span> Motorista interno não cadastrado </span>
          </template>
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>

        <div v-if="order.driver">
          Última placa usada pelo motorista: 
          <span class="red--text font-weight-bold">
            {{order?.driver?.attributes?.last_truck?.plate || "---"  }}
          </span> 
        </div>
        <v-autocomplete v-model="order.truck" :items="allTrucks" label="Caminhão interno"
          prepend-icon="mdi-truck" item-text="attributes.plate" return-object>
          <template v-slot:no-data>
            <span> Caminhão interno não cadastrado </span>
          </template>
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
      </template>

      <template v-if="!its_internal_drivers">
        <SelectDriverAndTruck :model="order"></SelectDriverAndTruck>
      </template>

    </template>

    <v-radio-group
      v-model="order.delivery_attributes.needs_pallets"
      label="Precisa de empréstimo de paletes?"
      row
      :rules="pallets_choice_rule"
      class="mt-2"
    >
      <v-radio :value="true" label="Sim"></v-radio>
      <v-radio :value="false" label="Não"></v-radio>
    </v-radio-group>

    <v-dialog ref="dialog" v-model="estimated_date_dialog" :return-value.sync="estimated_date" persistent width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-on="on" v-model="order.delivery_attributes.estimatedLoading"
          label="Data de carregamento" prepend-icon="mdi-calendar-range" readonly
          :rules="[...required]"></v-text-field>
      </template>
      <v-date-picker v-model="estimated_date" color="primary" locale="pt-br" scrollable>
        <v-spacer></v-spacer>
        <v-btn text icon color="error" @click="estimated_date_dialog = false"><v-icon>mdi-alert-circle</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn text icon color="success"
          @click="$refs.dialog.save(estimated_date)"><v-icon>mdi-check</v-icon></v-btn>
        <v-spacer></v-spacer>
      </v-date-picker>
    </v-dialog>

    <v-autocomplete v-model="order.logistic_id" :items="logistics" label="Responsável logística"
      prepend-icon="mdi-account-box-outline" item-text="name" :rules="[...required]" item-value="id">
      <template v-slot:no-data>
        <span> Funcionário nao encontrado </span>
      </template>
      <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
    </v-autocomplete>
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import Api from '@/api/index';

export default {
  name: 'SelectWholesaleOrderShipping',
  mixins: [ validations ],
  props: {
    order: {
      type: [Object],
    },
  },
  components: {
    SelectDriverAndTruck: () => import("@/components/create_order/wholesale_components/delivery_data/SelectDriverAndTruck.vue"),
  },
  data() {
    return {
      allDrivers: [],
      allTrucks: [],
      logistics: [],
      estimated_date: null,
      estimated_date_dialog: false,
      fill_later: false,
      pallets_choice_rule: [
        v => (v === true || v === false) || 'Selecione Sim ou Não'
      ],
      loading:{
        logistics: false,
        drivers: false,
      },
    }
  },
  methods: {
    getData() {
      this.getLogisticsEmployees()
      this.getDrivers()
      this.getTrucks()
    },
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    resetDriverAndTruck() {
      this.order.driver = null
      this.order.truck = null
    },
    getDrivers(){
      let params = {
        modality_ids: [this.order.modality_id],
        internal: true,
      }
      this.loading.drivers = true
      Api.Driver.index(params).then(res => res.data).then( res => {
        this.allDrivers = [ ...res.data ]
      }).finally(()=>{
        this.loading.drivers = false
      })
    },
    getTrucks(){
      let params = {
        modality_ids: [this.order.modality_id],
        internal: true,
      }
      this.loading.trucks = true
      Api.Truck.index(params).then(res => res.data).then( res => {
        this.allTrucks = [ ...res.data ]
      }).finally(()=>{
        this.loading.trucks = false
      })
    },
    getLogisticsEmployees() {
      this.loading.logistics = true
      const filter = {
        by_roles: ['Logistics'],
        modality_ids: [this.order.modality_id],
        status_ids: [1]
      }
      Api.Employee.index(filter).then(r => r.data).then(response => {
        let data = response.data ? response.data.map(a => a.attributes) : response
        this.logistics = [...data]
      }).finally(()=>{
        this.loading.logistics = false
      })
    },
  },
  computed: {
    its_internal_drivers(){
      return this.order.delivery_attributes.internal
    },
    switch_message(){
      return this.order?.delivery_attributes?.internal ? 'Frete interno' : 'Frete externo'
    },
  },
  mounted() {
    this.getData()
  },
  watch:{
    estimated_date() {
      this.order.delivery_attributes.estimatedLoading = this.formatDate(this.estimated_date)
    },
  }
}
</script>
